import { RootState } from "@custom-types/RootState";
import { Table, Form, Button, Container, Row, Col } from "react-bootstrap";
import { MReportTemplateAPI, MReportTemplateListResponse } from "api/sysadmin/m_report_template_api";
import { ReportRecord, AReportAPI } from "api/admin/a_report_api";
import { Messages } from "app_constants";
import axios from "axios";
import ReqState from "lib/reqstate";
import { useRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from "components/Loading";


type ReportFilter = {
  templateId: string;
  year: string;
  month: string;
};


export function ReportSelector(
  {templates, reportFilter, setReportFilter}:
  {
    templates: MReportTemplateListResponse
    reportFilter: ReportFilter;
    setReportFilter: React.Dispatch<ReportFilter>;
  }
) {
  return (
    <Row>
      <Col>
        <Form.Label htmlFor="template">帳票: </Form.Label>
        <Form.Select 
          id="template"
          onChange={(e) => setReportFilter({...reportFilter, "templateId": e.target.value})}
        >
          <option value="">▼選択してください</option>
          {
            templates.map((template) => (
              <option key={template.S} value={template.S}>
                {template.name}
              </option>
            ))
          }
        </Form.Select>
      </Col>
      <Col>
        <Form.Label htmlFor="year">年度：</Form.Label>
        <Form.Select
          onChange={(e) => setReportFilter({...reportFilter, "year": e.target.value})}
        >
          <option value="">---</option>
          <option>どういう風に年度出すか</option>
          <option value="2024">前年度</option>
          <option value="2025">2025年度</option>
        </Form.Select>
      </Col>
      <Col>
        <Form.Label htmlFor="year">月：</Form.Label>
        <Form.Select
          onChange={(e) => setReportFilter({...reportFilter, "month": e.target.value})}
        >
          <option value="">---</option>
          <option value="">どういう風に月出すか？クラス単位のほうがいいの？</option>
          {
            [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3].map((month) => (
              <option key={month}>
                {month}月
              </option>
            ))
          }
        </Form.Select>
      </Col>
    </Row>
  );
}


export default function TemplateListPage() {
  const navigate = useNavigate();
  const abortControllerRef = useRef<AbortController>();
  const [templates, setTemplates] = useState<MReportTemplateListResponse>([]);
  const [records, setRecords] = useState<Array<ReportRecord>>([]);
  const [reportFilter, setReportFilter] = useState<ReportFilter>({
    templateId: "",
    year: "",
    month: "",
  });
  const schoolInfo = useSelector((state: RootState) => state.schoolInfo);

  const [loadingState, setLoadingState] = useState(ReqState.INIT);
  const [loadingStateRecords, setLoadingStateRecords] = useState(ReqState.INIT);
  const [errorMsg] = useState(Messages.ServerError);

  useEffect(() => {
    abortControllerRef.current = new AbortController();

    async function fetchData() {
      try {
        const templates = await MReportTemplateAPI.list(abortControllerRef.current!.signal);
        setTemplates(templates);
        setLoadingState(ReqState.DONE);
      }
      catch (ex: unknown) {
        if (axios.isCancel(ex)) {
          return;
        }

        setLoadingState(ReqState.ERROR);
      }
    }

    fetchData();

    return () => {
      abortControllerRef.current!.abort();
    };
  }, []);
  
  const loadRecords = useCallback(async () => {
    try{
      setLoadingStateRecords(ReqState.DOING);
      const records  = await AReportAPI.list(
        reportFilter.templateId,
        "D19900101",
        "D20990731",
        "",
        "",
        abortControllerRef.current!.signal
      );
      setRecords(records);
      setLoadingStateRecords(ReqState.DONE);
    }
    catch (ex: unknown) {
      if (axios.isCancel(ex)) {
        return;
      }

      setLoadingState(ReqState.ERROR);
    }

  }, [setRecords, reportFilter.templateId]);

  useEffect(() => {
    if (reportFilter.templateId && reportFilter.year, reportFilter.month) {
      loadRecords();
    }
  }, [loadRecords, reportFilter.templateId, reportFilter.month, reportFilter.year]);


  return (
    <Loading
      isLoading={loadingState != ReqState.DONE}
      isLoadError={loadingState == ReqState.ERROR || loadingStateRecords == ReqState.ERROR}
      errorMsg={errorMsg}
    >
      <Container>
        <ReportSelector
          templates={templates}
          reportFilter={reportFilter}
          setReportFilter={setReportFilter}
        />

        { (reportFilter.templateId && reportFilter.year && reportFilter.month) &&
          <Row>
            <Col>
              <Table>
                <thead>
                  <tr>
                    <th>クラス名</th>
                    <th></th>
                  </tr>
                </thead>
                { loadingStateRecords == ReqState.DONE &&
                  <tbody>
                    {
                      schoolInfo.classList.filter(
                        (classObj) => classObj.delete != "1"
                      )
                      .map((classObj) => {
                        const record = records.find((record) => (record.id1 == classObj.cid)) || null;

                        return (
                          <tr key={classObj.cid}>
                            <td>{classObj.name}</td>
                            <td>
                              { record ?
                                  <>
                                    <Button
                                      onClick={() => navigate(`/viewer/${record.S}`)}
                                    >
                                      表示
                                    </Button>
                                    <Button
                                      onClick={() => navigate(`/form/edit/${reportFilter.templateId}/${record.S}`)}
                                    >
                                      編集
                                    </Button>
                                  </>
                                :
                                <Button
                                  onClick={() => navigate(`/form/new/${reportFilter.templateId}/${reportFilter.templateId}:D20250605:${classObj.cid}::`)}
                                >
                                  新規作成
                                </Button>
                              }
                            </td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                }
              </Table>
              <Loading
                isLoading={loadingStateRecords != ReqState.DONE}
              />
            </Col>
          </Row>
        }
      </Container>
    </Loading>
  );
}
